import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const ProtectedRoute = ({ children, requireSubscription = false }) => {
  const { user, loading } = useContext(AuthContext);
  const location = useLocation();

  // Show loading while checking authentication
  if (loading) {
    return <div>Loading...</div>;
  }

  // If not authenticated, redirect to login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // If subscription required and user is not active, redirect to checkout
  if (requireSubscription && user.subscriptionStatus !== 'active') {
    return <Navigate to="/checkout" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;